export default "__VITE_ASSET__D0eZad7u__"